export const queryKeys = {
    orders: (page?: number) => (page ? ['orders', page] as const : ['orders'] as const),
    orderById: (id: string) => ['orders', id] as const,
    clients: (page?: number) => (page ? ['clients', page] as const : ['clients'] as const),
    technicians: ['technicians'] as const,
    settings: ['settings'] as const,
    dashboardStats: ['dashboardStats'] as const,
};
